<template>
  <div class="channelRecord">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <div id="page-custoMersmanage">
          <div class="head-tab--nav">
            <div class="head-nav h-3 clearFloat">
              <span class="c-normal">{{ $t("Customersmanage.aa") }}</span>
              <div class="pull-right" v-if="pageActive == 'zero'">
                <el-button
                  v-if="postbe_crmlevel != 3"
                  type="warning"
                  @click="
                    getTypeCourseCatApi(), (showSliderBox = true);
                    (isrepeat = false), (isEdit = false);
                  "
                >
                  {{ $t("Customersmanage.ab") }}
                </el-button>
                <el-button type="primary" @click="daochu">{{
                  $t("Common.btn_export")
                }}</el-button>
              </div>
            </div>
          </div>
          <div class="custoMersmanage-container">
            <div class="content" style="padding-top: 0">
              <!-- <el-tabs v-model="pageActive" @tab-click="handleSliderClick"> -->
              <!-- <el-tab-pane :label="$t('Customersmanage.tabs1')" name="zero"> -->

              <div class="content-nav--head text-1 Tab-nav-head">
                <div class="c-n--head_lf">
                  <ul class="filter-condition">
                    <li
                      v-for="(item, index) in filtersOption"
                      :key="index"
                      :class="{ 'link-active': item.id == currentId }"
                      @click="changeFilter(item)"
                    >
                      <span class="tag-label">
                        {{ item.label }}
                        <span class="tag-num" v-if="item.value">{{
                          item.value
                        }}</span>
                      </span> 
                    </li>
                  </ul>
                </div>
              </div>

              <div
                v-if="isShowListTips && notreadnum > 0"
                class="listUpdate-tips"
              >
                <div class="tc">
                  <i class="el-icon-warning"></i>
                  <span
                    >{{ $t("Customersmanage.tips1") }}{{ notreadnum
                    }}{{ $t("Customersmanage.tips2") }}</span
                  >
                </div>
                <i
                  class="el-icon-close tip-close"
                  @click="isShowListTips = !isShowListTips"
                ></i>
              </div>
              <div v-if="!buttonHide" class="flex-wrap pl20 pr20 mt12">
                <div class="flex-al mb10 mr10">
                  <span class="mr10 fs14 color-666"
                    >{{ $t("Customersmanage.cba") }}：</span
                  >
                  <div class="time-box">
                    <el-date-picker
                      v-model="selectForm.range_time"
                      type="daterange"
                      style="width: 260px"
                      :range-separator="$t('Common.to')"
                      value-format="yyyy-MM-dd"
                      :start-placeholder="$t('Common.startTime')"
                      :end-placeholder="$t('Common.endTime')"
                      @change="handleSelect()"
                    ></el-date-picker>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <span class="mr10 fs14 color-666"
                    >{{ $t("Customersmanage.cbb") }}：</span
                  >
                  <div class="time-box">
                    <el-date-picker
                      v-model="selectForm.last_time"
                      type="daterange"
                      style="width: 260px"
                      :range-separator="$t('Common.to')"
                      value-format="yyyy-MM-dd"
                      :start-placeholder="$t('Common.startTime')"
                      :end-placeholder="$t('Common.endTime')"
                      @change="handleSelect()"
                    ></el-date-picker>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <span class="mr10 fs14 color-666">{{
                    $t("Customersmanage.ac")
                  }}</span>
                  <div class="rate-box flex-al">
                    <el-rate
                      v-model="client_levelvalue"
                      @change="handleSelectLevel()"
                      class="client-level-rate level-rate-fliter"
                      :icon-classes="['crm-likes', 'crm-likes', 'crm-likes']"
                      void-icon-class="crm-like"
                      :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                    ></el-rate>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      v-model="selectForm.client_tracestatus"
                      class="select-mini"
                      style="width: 150px"
                      clearable
                      :placeholder="$t('Customersmanage.ae')"
                      @change="handleSelect()"
                    >
                      <el-option
                        v-for="item in clientOptionList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.ishaveinvite"
                      class="select-mini"
                      style="width: 150px"
                      @change="handleSelect()"
                      :placeholder="$t('Customersmanage.cbc')"
                    >
                      <el-option
                        :label="
                          $t(
                            'views.Customersmanage.custoMersmanage.5zlnqvcggm00'
                          )
                        "
                        value="0"
                      ></el-option>
                      <el-option
                        :label="
                          $t(
                            'views.Customersmanage.custoMersmanage.5zlnqvcgj0w0'
                          )
                        "
                        value="1"
                      ></el-option>
                      <el-option
                        :label="
                          $t(
                            'views.Customersmanage.custoMersmanage.5zlnqvcgje00'
                          )
                        "
                        value="2"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.ishaveaudition"
                      class="select-mini"
                      style="width: 150px"
                      @change="handleSelect()"
                      :placeholder="$t('Customersmanage.cbd')"
                    >
                      <el-option
                        :label="
                          $t(
                            'views.Customersmanage.custoMersmanage.5zlnqvcgjlo0'
                          )
                        "
                        value="0"
                      ></el-option>
                      <el-option
                        :label="
                          $t(
                            'views.Customersmanage.custoMersmanage.5zlnqvcgjqo0'
                          )
                        "
                        value="1"
                      ></el-option>
                      <el-option
                        :label="
                          $t(
                            'views.Customersmanage.custoMersmanage.5zlnqvcgjwc0'
                          )
                        "
                        value="2"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.activity"
                      class="select-mini"
                      style="width: 150px"
                      @change="handleSelect()"
                      :placeholder="$t('Customersmanage.cbe')"
                    >
                      <el-option
                        v-for="item in ActivityOption"
                        :key="item.activity_id"
                        :label="item.activity_name"
                        :value="item.activity_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10" v-if="postbe_crmlevel == '1'">
                  <div class="select-box">
                    <el-select
                      filterable
                      v-model="selectForm.chiefPerson"
                      class="select-mini"
                      style="width: 150px"
                      clearable
                      :placeholder="$t('Customersmanage.cbf')"
                      @change="handleSelect()"
                    >
                      <el-option
                        v-for="item in chiefPerson"
                        :key="item.marketer_id"
                        :label="item.marketer_name"
                        :value="item.marketer_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.frommedia_name"
                      class="select-mini"
                      style="width: 150px"
                      @change="frommediaSearch"
                      :placeholder="$t('Customersmanage.cbg')"
                    >
                      <el-option
                        v-for="item in SchoolsourceOption"
                        :key="item.frommedia_id"
                        :label="item.frommedia_name"
                        :value="item.frommedia_name"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.channel_id"
                      class="select-mini"
                      style="width: 150px"
                      @change="handleSelect()"
                      :placeholder="$t('Customersmanage.cbh')"
                    >
                      <el-option
                        v-for="item in ChannelOption"
                        :key="item.channel_id"
                        :label="item.channel_name"
                        :value="item.channel_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      clearable
                      filterable
                      v-model="selectForm.client_isnewtip"
                      class="select-mini"
                      style="width: 180px"
                      @change="handleSelect()"
                      :placeholder="$t('Customersmanage.cbi')"
                    >
                      <el-option
                        :label="$t('Customersmanage.caf')"
                        value="1"
                      ></el-option>
                      <el-option
                        :label="$t('Customersmanage.cag')"
                        value="0"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.client_answerphone"
                      class="select-mini"
                      style="width: 150px"
                      @change="handleSelect()"
                      :placeholder="$t('Customersmanage.cbj')"
                    >
                      <el-option
                        v-for="(item, index) in clientAnswerphoneList"
                        :key="index"
                        :label="item.client_answerphone_name"
                        :value="item.client_answerphone"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-input
                      clearable
                      style="width: 160px"
                      :placeholder="$t('Customersmanage.cbk')"
                      v-model="selectForm.track_count"
                      @change="handleSelect()"
                    ></el-input>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.nohavetrack"
                      class="select-mini"
                      style="width: 200px"
                      @change="handleSelect()"
                      :placeholder="$t('Customersmanage.cbl')"
                    >
                      <el-option
                        :label="
                          $t(
                            'views.Customersmanage.custoMersmanage.5zlnqvcgk1s0'
                          )
                        "
                        value="1"
                      ></el-option>
                      <el-option
                        :label="
                          $t(
                            'views.Customersmanage.custoMersmanage.5zlnqvcgk640'
                          )
                        "
                        value="0"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al Inquire-box mb10">
                  <div class="ipt-box">
                    <el-input
                      clearable
                      style="width: 430px"
                      :placeholder="$t('Customersmanage.cbm')"
                      v-model="selectForm.keyword"
                      @change="handleSelectKeyword()"
                    ></el-input>
                  </div>
                  <el-button
                    type="primary"
                    class="btn-inquire"
                    style="margin-right: 0px"
                    @click="handleSelectKeyword()"
                    >{{ $t("Customersmanage.an") }}</el-button
                  >
                </div>
              </div>
              <div v-else-if="buttonHide" class="flex-wrap pl20 pr20 mt12">
                <div class="flex-al mb10 mr10">
                  <el-button type="warning" @click="handleClickclueloss(1)">
                    {{ $t("Customersmanage.ao") }}
                  </el-button>
                </div>
                <div class="flex-al mb10 mr10">
                  <!-- 只有主管权限可以看见 -->
                  <el-button
                    v-if="postbe_crmlevel == '1' && !isFromGmc && companyIsNoIntention"
                    type="primary"
                    @click="handleClickclueloss(-1)"
                  >
                    {{ $t("Customersmanage.ap") }}
                  </el-button>

                  <el-button
                    v-if="postbe_crmlevel == '1' && !isFromGmc"
                    type="primary"
                    @click="
                      getInvalidnoteApi(),
                        (followForm.invalidnote_code = ''),
                        (invalidVisible = true)
                    "
                  >
                    批量无效
                  </el-button>
                </div>
                <!-- <div class="flex-al mb10 mr10">
                      <el-button type="danger" @click="batchAddPhone"
                        >{{$t('views.Customersmanage.custoMersmanage.5zlnqvcgkbg0')}}</el-button
                      >
                    </div> -->
              </div>
              <div class="pl20 pr20">
                <div
                  class="table-list"
                  style="position: relative"
                  ref="auto_height_table"
                >
                  <TableList
                    :list="tableData"
                    :options="optionscaozuo"
                    :columns="columns"
                    :operates="operates"
                    :issetting="true"
                    :isSort="true"
                    :isCall="true"
                    :tableOperate="tableOperate"
                    :tableSort="tableSort"
                    @handleCommandSort="handleCommandSort"
                    @toggleEditableColumn="toggleEditableColumn"
                    @handleSelectionChange="handleSelectionChange"
                    @handleColumnChange="handleColumnChange"
                    @emitCallPhone="emitCallPhone"
                    ref="multipleTable"
                  ></TableList>
                  <div class="personalInfo-tips">
                    <i class="crmIcon-ysbh"></i>
                    <span>{{ $t("Common.personalInfo_tips") }}</span>
                  </div>
                </div>
                <el-pagination
                  style="margin-top: 20px"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[10, 20, 30, 40]"
                  :page-size="pagesize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="dataNumber"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </el-main>
    </PageNav>

    <!-- 侧边新建栏 -->
    <!-- 侧边栏 -->
    <SliderBox
      :showSliderBox="showSliderBox"
      :sliderWidth="sliderWidth"
      @hideSliderBox="(showSliderBox = false), (isrepeat = false)"
    >
      <userCreate
        :showUserSliderBox="showSliderBox"
        :Userlist="Userlistcreate"
        :isCustomer="true"
        :clientOption="clientOption"
        :SchoolsourceOption="SchoolsourceOption"
        :chiefPerson="chiefPerson"
        :SchoolCourseOption="SchoolCourseOption"
        :isrepeat="isrepeat"
        :repeatList="repeatList"
        :FamilyRelation="FamilyRelation"
        @onSubmit="onSubmit"
        @wantToTrack="wantToTrack"
        @hideUserSliderBox="hideSliderBox"
        @checkIntentionClientData="checkIntentionClientData"
      ></userCreate>
    </SliderBox>
    <!-- 侧边栏查看-->
    <SliderBox
      :showSliderBox="showSliderBoxSee"
      class="user-seeing-slider"
      @hideSliderBox="hideSliderSeeBox"
      :sliderWidth="sliderWidth"
    >
      <userSeeing
        :showUserSliderBox="showSliderBoxSee"
        :createJG="createJG"
        :customerId="customerId"
        :ClassMessage="ClassMessage"
        :isTrack="isTrack"
        :isRoot="isRoot"
        :iscanEdit="iscanEdit"
        :seeSliderTitle="seeSliderTitle"
        @hideUserSliderBox="hideSliderSeeBox"
        @studentBinding="studentBinding"
        @handleSliderClick="handleSliderClick"
        @Clickedit="Clickedit"
        @leaning="leaning"
        @onFllowSubmit="onFllowSubmit"
        @ClickFloow="ClickFloow"
        @ClickAudition="ClickAudition"
        @ClickAuditiontime="ClickAuditiontime"
        @emitShowImg="emitShowImg"
        @updateList="updateList"
        :showCallPhone="true"
        @emitCallPhone="emitCallPhone"
      ></userSeeing>
    </SliderBox>
    <!-- 侧边栏编辑-->
    <SliderBox
      :showSliderBox="showSliderBoxEdit"
      @hideSliderBox="hideSliderBoxEdit"
      :sliderWidth="sliderWidth"
    >
      <userCreate
        :showUserSliderBox="showSliderBoxEdit"
        :Userlist="Userlistedit"
        @hideUserSliderBox="hideSliderBoxEdit"
        :clientOption="clientOption"
        :SchoolsourceOption="SchoolsourceOption"
        :chiefPerson="chiefPerson"
        :SchoolCourseOption="SchoolCourseOption"
        :isrepeat="isrepeat"
        :isEdit="isEdit"
        :FamilyRelation="FamilyRelation"
        :UserInformation="UserInformation"
        :repeatList="repeatList"
        @onSubmit="oneditSubmit"
        @checkIntentionClientData="checkIntentionClientData"
        @deleteFamily="deleteFamily"
        @deleteCourse="deleteCourse"
        @wantToTrack="wantToTrack"
      ></userCreate>
    </SliderBox>
    <!-- 绑定学员 -->
    <el-dialog
      :title="$t('Customersmanage.aq')"
      :visible.sync="createJG"
      class="tan-binding"
      width="30%"
      :before-close="handleClose"
    >
      <div class="create">
        <el-form
          label-width="120px"
          ref="BindstudentFrom"
          :model="BindstudentFrom"
        >
          <el-form-item
            :label="$t('Customersmanage.ar')"
            prop="name"
            :rules="[
              {
                required: true,
                message: $t(
                  'views.Customersmanage.custoMersmanage.5zlnqvcglgk0'
                ),
              },
            ]"
          >
            <el-select
              filterable
              v-model="BindstudentFrom.name"
              remote
              :remote-method="remoteMethod"
              :loading="loading"
              style="width: 200px"
              :placeholder="$t('Customersmanage.as')"
            >
              <el-option
                v-for="item in FriendName"
                :key="item.client_id"
                :value="item.client_id"
                :label="item.client_cnname"
              >
                {{ item.client_cnname }}
                <i slot="suffix" class="el-input__icon el-icon-date"></i>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('Customersmanage.at')"
            prop="relation"
            :rules="[
              {
                required: true,
                message: $t(
                  'views.Customersmanage.custoMersmanage.5zlnqvch2ms0'
                ),
              },
            ]"
          >
            <el-select
              filterable
              v-model="BindstudentFrom.relation"
              style="width: 200px"
              :placeholder="$t('Customersmanage.au')"
            >
              <el-option
                v-for="item in FriendRelation"
                :key="item.friendrelation_id"
                :value="item.friendrelation_name"
                :label="item.friendrelation_name"
                >{{ item.friendrelation_name }}</el-option
              >
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onBindSubmit()">{{
          $t("Customersmanage.av")
        }}</el-button>
        <!-- <el-button @click="createJG = false">取 消</el-button> -->
      </span>
    </el-dialog>
    <!-- 跟班试听 中间-->
    <auditClass
      :leaningVisible="leaningVisible"
      :auditionGenre="auditionGenre"
      :Auditiontime="Auditiontime"
      @handClickcompare="handClickcompare"
      @handClickcancel="handClickcancel"
      @handleClose="handleCloseLean"
    ></auditClass>
    <!-- 编辑列 -->
    <el-dialog
      :title="$t('Customersmanage.aw')"
      class="setting-column"
      :visible.sync="settingVisible"
      width="450px"
      :before-close="handleClose"
    >
      <el-transfer
        :titles="[$t('Customersmanage.ax'), $t('Customersmanage.ay')]"
        v-model="oprateColumn"
        @change="Changeoprate()"
        :data="data"
      ></el-transfer>
      <div class="oprate">
        <el-button type="primary" size="small" @click="handClickOprate()">{{
          $t("Customersmanage.av")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 不是我的意向客户提示 -->
    <el-dialog
      :title="$t('Customersmanage.az')"
      :visible.sync="TipsVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="del-box">
        <div class="delTips tc">{{ TipsText }}!</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="TipsVisible = false">{{
          $t("Customersmanage.av")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 转正学员*****弹框 -->
    <el-dialog
      :title="$t('Customersmanage.ba')"
      :visible.sync="positiveVisable"
      class="tan-binding"
      width="500px"
      :before-close="handleClose"
    >
      <div class="positive-div">
        <el-form
          label-width="120px"
          ref="PositiveFrom"
          :model="PositiveFrom"
          :rules="positiveRules"
        >
          <el-form-item :label="$t('Customersmanage.bb')" prop="student_branch">
            <el-input
              v-model="PositiveFrom.student_branch"
              style="width: 260px"
              :placeholder="$t('Customersmanage.bc')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('Customersmanage.bd')" prop="course_branch">
            <el-select
              filterable
              clearable
              v-model="PositiveFrom.course_branch"
              style="width: 260px"
              :placeholder="$t('Customersmanage.be')"
            >
              <el-option
                v-for="(item, index) in courseBranchList"
                :key="index"
                :value="item.course_branch"
                :label="`${item.course_cnname}(${item.course_branch})`"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('Customersmanage.bf')"
            prop="positivelog_time"
          >
            <el-date-picker
              type="date"
              :placeholder="$t('Customersmanage.bg')"
              v-model="PositiveFrom.positivelog_time"
              style="width: 260px"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Customersmanage.bh')">
            <el-input
              v-model="PositiveFrom.positvelog_note"
              style="width: 260px"
              type="textarea"
              maxlength="50"
              :placeholder="$t('Customersmanage.bi')"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onTurnSubmit()">{{
          $t("Customersmanage.av")
        }}</el-button>
        <el-button @click="positiveVisable = false">{{
          $t("Customersmanage.bj")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 转正学员*****弹框 -->
    <el-dialog
      :title="$t('views.Customersmanage.custoMersmanage.5zlnqvch2zg0')"
      :visible.sync="showApplyPop"
      class="tan-binding"
      width="600px"
      :before-close="handleClose"
    >
      <div class="positive-div">
        <el-form
          label-width="120px"
          ref="PositiveFrom"
          :model="PositiveFrom"
          :rules="positiveRules"
        >
          <div class="choose-user-row">
            <span class="tit">已选择客户(5):</span>
            <div class="user-content">
              <span
                @click="removeUser(index)"
                v-for="(item, index) in chooseUserList"
                :key="index"
                class="user-content-item"
              >
                {{ $t("views.Customersmanage.custoMersmanage.5zlnqvch3400") }}
                {{ index }}
                <i class="el-icon-circle-close"></i>
              </span>
            </div>
          </div>
          <el-form-item
            :label="$t('Customersmanage.bh')"
            prop="positvelog_note"
          >
            <el-input
              v-model="PositiveFrom.positvelog_note"
              style="width: 260px"
              type="textarea"
              maxlength="50"
              :placeholder="$t('Customersmanage.bi')"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onTurnSubmit()">{{
          $t("Customersmanage.av")
        }}</el-button>
        <el-button @click="showApplyPop = false">{{
          $t("Customersmanage.bj")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 删除重复名单提示 -->
    <el-dialog
      :title="$t('Customersmanage.az')"
      :visible.sync="delRepeat"
      width="30%"
      :before-close="handleClose"
    >
      <div class="del-box">
        <div class="delTips tc">{{ $t("Customersmanage.bl") }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="delRepeatAction()">{{
          $t("Customersmanage.av")
        }}</el-button>
        <el-button @click="delRepeat = false">{{
          $t("Customersmanage.bk")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 申请变更渠道 -->
    <SliderBox
      :showSliderBox="showApplyChange"
      :sliderWidth="minSliderwidth"
      @hideSliderBox="showApplyChange = false"
    >
      <div class="silder-contain slider-admissionCue slider-top-see">
        <div class="slider-top clearFloat">
          <p class="h3 slider-title pull-left">
            {{ $t("Customersmanage.cbn") }}
          </p>
          <el-button
            type="default"
            class="pull-right"
            @click="showApplyChange = false"
          >
            {{ $t("views.Customersmanage.custoMersmanage.5zlnqvch3840") }}
          </el-button>
          <el-button
            @click="handleApply"
            type="primary"
            class="pull-right mr20"
          >
            {{ $t("Customersmanage.eab") }}
          </el-button>
        </div>
        <div class="slider-cont text-1">
          <template v-if="applyChannelRow">
            <div class="apply-channel__desc" v-if="applyChannelRow.status == 1">
              <em class="el-icon-warning mr10"></em>
              {{ $t("views.Customersmanage.custoMersmanage.5zlnqvch3lk0") }}
            </div>
            <div class="apply-user-pop">
              <div class="user-info__img">
                <img
                  :src="
                    applyChannelRow.client_img ||
                    (applyChannelRow.client_sex ==
                    $t('views.Customersmanage.custoMersmanage.5zlnqvch3q00')
                      ? require('@/assets/images/default-img-man.png')
                      : require('@/assets/images/default-img-women.png'))
                  "
                  alt=""
                />
              </div>
              <span class="user-info__name"
                >{{ applyChannelRow.client_cnname }}
                <em class="user-tips" v-if="applyChannelRow.status == 1">
                  {{ $t("views.Customersmanage.custoMersmanage.5zlnqvch3wg0") }}
                </em>
              </span>
            </div>
            <el-form
              :model="applyFormData"
              ref="applyFormRef"
              label-width="120px"
            >
              <el-form-item
                :label="
                  $t('views.Customersmanage.custoMersmanage.5zlnqvch40s0')
                "
              >
                <el-input
                  disabled
                  style="width: 340px"
                  v-model="applyChannelRow.channel_medianame"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="
                  $t('views.Customersmanage.custoMersmanage.5zlnqvch4400')
                "
              >
                <el-input
                  disabled
                  style="width: 340px"
                  v-model="applyChannelRow.channel_name"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="
                  $t('views.Customersmanage.custoMersmanage.5zlnqvch47o0')
                "
                prop="frommedia_id"
                :rules="[
                  {
                    required: true,
                    message: $t(
                      'views.Customersmanage.custoMersmanage.5zlnqvch4cw0'
                    ),
                  },
                ]"
              >
                <el-select
                  filterable
                  clearable
                  style="width: 340px"
                  :placeholder="
                    $t('views.Customersmanage.custoMersmanage.5zlnqvch4cw0')
                  "
                  v-model="applyFormData.frommedia_id"
                  @change="applyChannelChange"
                >
                  <el-option
                    v-for="(item, index) in applyFormData.sourceList"
                    :key="index"
                    :label="item.frommedia_name"
                    :value="item.frommedia_id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                :label="
                  $t('views.Customersmanage.custoMersmanage.5zlnqvch4g00')
                "
                prop="channel_id"
                :rules="[
                  {
                    required: true,
                    message: $t(
                      'views.Customersmanage.custoMersmanage.5zlnqvch4j40'
                    ),
                  },
                ]"
              >
                <el-select
                  filterable
                  clearable
                  style="width: 340px"
                  :placeholder="
                    $t('views.Customersmanage.custoMersmanage.5zlnqvch4j40')
                  "
                  v-model="applyFormData.channel_id"
                  @change="applyFormData.promotion_id = ''"
                >
                  <el-option
                    v-for="(item, index) in applyFormData.channelList"
                    :key="index"
                    :label="item.channel_name"
                    :value="item.channel_id"
                  ></el-option>
                </el-select>
              </el-form-item>

              <template
                v-if="
                  applyFormData.channel_id == 436 &&
                  $store.state.COMPANY_ID === '8888'
                "
              >
                <el-form-item
                  :label="
                    $t('views.Customersmanage.custoMersmanage.5zlnqvch4m00')
                  "
                  prop="promotion_id"
                >
                  <el-select
                    filterable
                    v-model="applyFormData.promotion_id"
                    style="width: 340px"
                    :placeholder="
                      $t('views.Customersmanage.custoMersmanage.5zlnqvch4oc0')
                    "
                    reserve-keyword
                    remote
                    :remote-method="remotePromotion"
                    :loading="loading"
                  >
                    <el-option
                      v-for="item in groundPromotionList"
                      :key="item.promotion_id"
                      :label="`${item.promotion_name}（${item.promotion_jobnumber}）`"
                      :value="item.promotion_id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </template>

              <template
                v-if="
                  applyFormData.frommedia_id == '387' &&
                  applyFormData.channel_id == '107' &&
                  $store.state.COMPANY_ID === '8888'
                "
              >
                <el-form-item class="recommend-content">
                  <el-input
                    v-model="applyFormData.recommend_keyword"
                    style="width: 283px"
                    @clear="searchRecomend"
                    @input="$forceUpdate()"
                    @keyup.enter.native="searchRecomend"
                    :placeholder="$t('User.placeholder18')"
                  >
                    <i
                      slot="suffix"
                      @click="searchRecomend"
                      class="el-input__icon cur-pointer el-icon-search"
                    ></i>
                  </el-input>
                  <el-button
                    type="primary"
                    size="large"
                    @click="searchRecomend"
                    >{{
                      $t("views.Customersmanage.custoMersmanage.5zlnqvch4r00")
                    }}</el-button
                  >
                  <!-- 弹出框 -->
                  <div
                    @click.stop
                    v-if="recommendPopVisable"
                    class="recommend-poplist"
                  >
                    <radioTableCont
                      :tableData="tableList"
                      @singleBox="singleBox"
                    ></radioTableCont>
                    <div class="pop__arrow"></div>
                  </div>
                </el-form-item>
                <el-form-item
                  :label="$t('User.label_text22')"
                  prop="client_sponsor"
                  :rules="[
                    {
                      required: true,
                      message: $t(
                        'views.Customersmanage.custoMersmanage.5zlnqvch4to0'
                      ),
                    },
                  ]"
                >
                  <div
                    v-if="selecRecomInfo.student_cnname"
                    class="recommend-info"
                  >
                    {{ selecRecomInfo.student_cnname }}
                    {{ selecRecomInfo.student_enname }}
                    {{ selecRecomInfo.parenter_mobile }}
                    <span></span>
                    {{ $t("User.label_text23")
                    }}{{ selecRecomInfo.school_cnname }}
                  </div>
                  <div v-else>{{ $t("User.tips") }}</div>
                </el-form-item>

                <el-form-item
                  :rules="[
                    {
                      required: true,
                      message: $t(
                        'views.Customersmanage.custoMersmanage.5zlnqvch4w40'
                      ),
                    },
                  ]"
                  :label="
                    $t('views.Customersmanage.custoMersmanage.5zlnqvch4y80')
                  "
                  prop="client_teacherid"
                >
                  <el-select
                    filterable
                    v-model="applyFormData.client_teacherid"
                    clearable
                    style="width: 340px"
                    :placeholder="
                      $t('views.Customersmanage.custoMersmanage.5zlnqvch4w40')
                    "
                    @change="filterClientTeacher"
                  >
                    <el-option
                      v-for="item in recommendTeacherList"
                      :key="item.staffer_id"
                      :label="item.marketer_name"
                      :value="item.staffer_id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </template>

              <el-form-item
                :label="
                  $t('views.Customersmanage.custoMersmanage.5zlnqvch50k0')
                "
                prop="channellog_changetime"
                style="width: 340px"
                :rules="[
                  {
                    required: true,
                    message: $t(
                      'views.Customersmanage.custoMersmanage.5zlnqvch5340'
                    ),
                  },
                ]"
              >
                <el-date-picker
                  type="date"
                  :placeholder="
                    $t('views.Customersmanage.custoMersmanage.5zlnqvch5340')
                  "
                  value-format="yyyy-MM-dd"
                  v-model="applyFormData.channellog_changetime"
                  style="width: 340px"
                ></el-date-picker>
              </el-form-item>
              <!-- <el-form-item
                :label="$t('views.Customersmanage.custoMersmanage.5zlnqvch5980')"
                prop="channellog_img"
                style="width: 340px"
              >
                <el-upload
                  class="avatar-uploader"
                  :action="$uploadAction('/Uploading/Picture')"
                  name="ossfile"
                  :data="Uploadeimg"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                >
                  <div
                    style="
                      height: 100%;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      flex-direction: column;
                    "
                  >
                    <img
                      v-if="applyFormData.channellog_img"
                      :src="applyFormData.channellog_img"
                    />
                    <template v-else>
                      <i class="el-icon-plus"></i>
                      <div class="el-upload__text">{{$t('views.Customersmanage.custoMersmanage.5zlnqvch5bk0')}}</div>
                    </template>
                  </div>
                </el-upload>
              </el-form-item> -->

              <el-form-item
                :label="
                  $t('views.Customersmanage.custoMersmanage.5zlnqvch5980')
                "
                prop="channellog_img"
              >
                <el-upload
                  ref="uploadRef"
                  class="avatar-uploader"
                  id="uploadSty"
                  :action="$uploadAction('/Uploading/Picture')"
                  name="ossfile"
                  :multiple="multiple"
                  :data="Uploadeimg"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                  list-type="picture-card"
                  :file-list="fileList"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                >
                  <i
                    style="display: block; padding-top: 50px"
                    class="el-icon-plus"
                  ></i>
                  <div style="margin-top: -50px" class="el-upload__text">
                    {{
                      $t("views.Customersmanage.custoMersmanage.5zlnqvch5bk0")
                    }}
                  </div>

                  <el-dialog
                    id="dialogSty"
                    :visible.sync="dialogVisibles"
                    :modal-append-to-body="false"
                    append-to-body
                  >
                    <img
                      width="100%"
                      :src="applyFormData.channellog_img2"
                      alt=""
                    />
                  </el-dialog>
                </el-upload>
              </el-form-item>

              <el-form-item
                :label="
                  $t('views.Customersmanage.custoMersmanage.5zlnqvch5e80')
                "
                prop="reason"
                :rules="[
                  {
                    required: true,
                    message: $t(
                      'views.Customersmanage.custoMersmanage.5zlnqvch5gk0'
                    ),
                  },
                ]"
              >
                <el-input
                  type="textarea"
                  :rows="6"
                  style="width: 340px"
                  v-model="applyFormData.reason"
                  :placeholder="
                    $t('views.Customersmanage.custoMersmanage.5zlnqvch5gk0')
                  "
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="
                  $t('views.Customersmanage.custoMersmanage.5zlnqvch5io0')
                "
                prop="degree"
                :rules="[
                  {
                    required: true,
                    message: $t(
                      'views.Customersmanage.custoMersmanage.5zlnqvch5l00'
                    ),
                  },
                ]"
              >
                <el-select
                  filterable
                  clearable
                  style="width: 340px"
                  :placeholder="
                    $t('views.Customersmanage.custoMersmanage.5zlnqvch5l00')
                  "
                  v-model="applyFormData.degree"
                >
                  <el-option
                    v-for="(item, index) in applyFormData.degreeList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </template>
          <!--<div class="apply-channel__notice mt20 ml20">
            <em class="el-icon-warning"></em>
            {{$t('views.Customersmanage.custoMersmanage.5zlnqvch5nk0')}}
          </div>-->
        </div>
      </div>
    </SliderBox>

    <dialPhone :showPhoneDialog="showPhoneDialog" @handClose="hidePhoneDialog">
    </dialPhone>
    <!-- <div @click="showImgMask = false" v-if="showImgMask" class="show-img__mask">
      <img :src="showImgUrl" alt="" />
    </div> -->

    <div id="viewerStyle" v-if="showImgMask">
      <el-image-viewer
        v-if="showViewer"
        :on-close="closeViewer"
        :url-list="showImgUrl"
      >
      </el-image-viewer>
    </div>

    <!-- <div @click="handDialPhone" class="dial_area">
      <div class="dial_top">
        <img :src="require('@/assets/images/customer/phone-icon.png')" alt="" />
        <span>{{$t('views.Customersmanage.custoMersmanage.5zlnqvch5qw0')}}</span>
      </div>
      <img :src="require('@/assets/images/customer/drop-down.png')" alt="" />
    </div> -->

    <el-dialog
      :title="$t('views.Customersmanage.custoMersmanage.5zlnqvch5t40')"
      :visible.sync="repeatVisible"
      class="tan-binding"
      width="800px"
      :before-close="handleClose"
      :append-to-body="true"
    >
      <div class="repeat-content">
        <p class="mb20">
          {{ $t("views.Customersmanage.custoMersmanage.5zlnqvch5v40") }}
        </p>
        <normalTableCont :tableData="repeatData"></normalTableCont>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitChangePhone">
          {{ $t("views.Customersmanage.custoMersmanage.5zlnqvch5xs0") }}
        </el-button>
        <el-button @click="cancelChangePhone">{{
          $t("views.Customersmanage.custoMersmanage.5zlnqvch3840")
        }}</el-button>
      </span>
    </el-dialog>

    <div v-if="callPhoneVisible" class="call-phone-dialog">
      <div class="callphone-dialog flex-col flex-cc fs17 tc">
        <div class="close" @click="callPhoneVisible = false">
          <i
            class="el-icon-close"
            style="color: #fff; font-size: 26px; cursor: pointer"
          ></i>
        </div>
        <template v-if="callProcess == 1">
          <p class="title">
            {{ $t("views.Customersmanage.custoMersmanage.5zlnqvch5qw0") }}
          </p>
          <p class="tips-1">
            {{ $t("views.Customersmanage.custoMersmanage.5zlnqvch6040") }}
          </p>
          <p class="tips-2">
            {{ $t("views.Customersmanage.custoMersmanage.5zlnqvch62g0") }}
          </p>
          <div class="way">
            <el-radio-group v-model="callPhoneType" direction="horizontal">
              <el-radio label="1">{{
                $t("views.Customersmanage.custoMersmanage.5zlnqvch65c0")
              }}</el-radio>
              <el-radio label="2">{{
                $t("views.Customersmanage.custoMersmanage.5zlnqvch67k0")
              }}</el-radio>
              <el-radio label="3" 
                v-if="seatsIntentionLevel && seatsIntentionLevel.includes(rowData.client_intention_level)"
              >
                400电话
              </el-radio>
            </el-radio-group>
            <p class="color-orange mt20 fs14" v-if="seatsIntentionLevel">
              400电话仅对{{ seatsIntentionLevel.split(',').map(v => v+'星').join('、') }}客户开放
            </p>
          </div>
          <div class="callphone-button" @click="callClientMobileAction">
            {{ $t("views.Customersmanage.custoMersmanage.5zlnqvch6ak0") }}
          </div>
        </template>
        <template v-else-if="callProcess == 2">
          <img
            class="tips-process"
            src="@/assets/images/calling-icon.png"
            alt=""
          />
          <p class="title-1">{{ errortip }}</p>
          <div class="callphone-button" block @click="callPhoneVisible = false">
            {{ $t("views.Customersmanage.custoMersmanage.5zlnqvch6dc0") }}
          </div>
        </template>
        <template v-else-if="callProcess == 3">
          <img
            class="tips-process"
            src="@/assets/images/calling-warn-icon.png"
            alt=""
          />
          <p class="title-1">{{ errortip }}</p>
          <div class="callphone-button" block @click="callPhoneVisible = false">
            {{ $t("views.Customersmanage.custoMersmanage.5zlnqvch6dc0") }}
          </div>
        </template>
      </div>
    </div>

    <el-dialog
      title="批量无效"
      class="mulSelect"
      :visible.sync="invalidVisible"
      width="450px"
      :before-close="handClose"
      v-if="invalidVisible"
    >
      <div class="form">
        <p class="number-tips mb10">
          {{ $t("views.ListAllocationManagement.preSetValidList.636vv9ochcs0")
          }}<span style="color: #27aad8"> {{ MultipleClues.length }} </span
          >条名单，是否批量设置无效名单？
        </p>
        <ul class="selected-people-container">
          <li
            class="selected-people-item"
            v-for="(item, index) in MultipleClues"
            :key="index"
          >
            {{ item.client_cnname }}
            <i
              class="el-icon-error"
              style="color: red"
              @click="handleRemoveItem(index)"
            ></i>
          </li>
        </ul>

        <el-form ref="followForm" :model="followForm">
          <el-form-item
            label="无效原因："
            :rules="[{ required: true, message: '请选择无效原因' }]"
            prop="invalidnote_code"
          >
            <el-select
              filterable
              v-model="followForm.invalidnote_code"
              style="width: 250px"
              placeholder="请选择无效原因"
            >
              <el-option
                v-for="items in followForm.invalidNoteList"
                :key="items.invalidnote_code"
                :label="items.invalidnote_reason"
                :value="items.invalidnote_code"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleConfimInvalid" type="primary" size="small">{{
          $t("views.ListAllocationManagement.preSetValidList.636vv9ochkg0")
        }}</el-button>
        <el-button @click="invalidVisible = false" size="small">{{
          $t("views.ListAllocationManagement.preSetValidList.636vv9ochnc0")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import util from "@/utils/util";
import ElImageViewer from "../../../node_modules/element-ui/packages/image/src/image-viewer";
import PageNav from "@/components/Nav/nav.vue";
// import echarts from "echarts";
import SliderBox from "@/components/SliderBox";
import TableList from "@/components/Table/table.vue";
import userCreate from "@/components/User/create.vue";
import userSeeing from "@/components/User/seeing.vue";
import dialPhone from "@/components/User/dialPhone.vue";
import auditClass from "@/components/Class/Class.vue";
import storeCustoMersmanage from "./channelRecord.js";
import radioTableCont from "@/components/tables/radioTableCont";
import normalTableCont from "@/components/Table/normalTableCont.vue";

export default {
  name: "CustoMersmanage-custoMersmanage",
  data() {
    return {
      rowData: {},
      // overduetype 1 常规跟进 2 跟进逾期 3 低频跟进预警名单
      currentId: 4,
      /*{ label: "未跟进名单", value: 0, id: 4 },
      { label: "未接通名单", value: 0, id: 5 },*/
      filtersOption: [
        { label: "未跟进名单", value: 0, id: 4 },
        { label: "跟进中名单", value: 0, id: 1 },
        { label: "低跟进名单", value: 0, id: 2 },
        { label: "低跟进预警名单", value: 0, id: 3 },
      ],

      invalidVisible: false,
      followForm: { invalidNoteList: [], invalidnote_code: "" },

      errortip: "",
      callItem: null,
      callPhoneVisible: false,
      callPhoneType: "1",
      callProcess: "1",

      loading: false,

      groundPromotionList: [],

      repeatVisible: false,
      repeatData: {
        list: [],
        columns: [],
        options: {
          tableHeight: 300,
          errortip: "",
        },
      },

      showViewer: false, // 显示查看器
      isFromGmc: false, // 是否来源于集团
      multiple: true,
      // dialogImageUrl: '',
      dialogVisibles: false,
      fileList: [],
      showImgMask: false,
      // showImgUrl: "",
      showImgUrl: [],
      Uploadeimg: {
        company_id: this.$store.state.COMPANY_ID,
        ossfile: "",
      },

      openMenu: ["3"],
      showApplyPop: false, // 申请协助跟踪
      chooseUserList: [{}, {}, {}, {}, {}, {}, {}],
      pageActive: "zero",
      showSliderBox: false,
      showSliderBoxSee: false,
      showSliderBoxEdit: false,
      settingVisible: false,
      positiveVisable: false, //转正学员
      delRepeat: false, //删除重复名单
      leaningVisible: false,
      TipsVisible: false, //不是我的意向客户提示
      iscanEdit: true,
      fullscreenLoading: true, //全屏loading
      oprateColumn: [1, 4], //编辑列
      showColumn: [],
      ClassMessage: {}, //选择的试听班级
      data: [],
      isEdit: true,
      createJG: false,
      seeSliderTitle: this.$t("Customersmanage.bm"),
      TipsText: this.$t("Customersmanage.bn"), //不能跟进的提示语
      customerId: "", // 客户id
      isTrack: false, //是否点击跟进
      isRoot: false,

      applyChannelRow: null,
      showApplyChange: false, // 变更渠道显示
      applyFormData: {
        frommedia_id: "",
        frommedia_name: "",
        channellog_changetime: "",
        client_teacherid: "",
        client_teachername: "",
        promotion_id: "",
        client_sponsor: "",
        recommend_keyword: "",
        // channellog_img: "",
        channellog_img: [],
        channellog_img2: "",
        // fileList: [],
        sourceList: [], // 渠道类型
        channel_id: "",
        channelList: [], // 渠道明细
        reason: "",
        degree: "",
        degreeList: [
          {
            label: this.$t(
              "views.Customersmanage.custoMersmanage.5zlnqvch6h40"
            ),
            value: "0",
          },
          {
            label: this.$t(
              "views.Customersmanage.custoMersmanage.5zlnqvch6m80"
            ),
            value: "1",
          },
          {
            label: this.$t(
              "views.Customersmanage.custoMersmanage.5zlnqvch6os0"
            ),
            value: "2",
          },
        ],
      },

      //转正学员
      PositiveFrom: {
        student_branch: "", //学生编号
        course_branch: "", //课程编号
        positivelog_time: "", //转正日期
        positvelog_note: "", //转正备注
      },
      clientId: "", //单个客户id
      courseBranchList: [], //课程别列表*****转正学员
      //转正学员*****校验规则
      positiveRules: {
        student_branch: [
          {
            required: true,
            message: this.$t("Customersmanage.bo"),
            trigger: "blur",
          },
        ],
        course_branch: [
          {
            required: true,
            message: this.$t("Customersmanage.bp"),
            trigger: "change",
          },
        ],
        positivelog_time: [
          {
            required: true,
            message: this.$t("Customersmanage.bq"),
            trigger: "change",
          },
        ],
        positvelog_note: [
          {
            required: true,
            message: this.$t("Customersmanage.bq"),
            trigger: "change",
          },
        ],
      },
      //绑定学员
      BindstudentFrom: {
        name: "",
        relation: "",
      },
      //用户基本信息
      UserInformation: [],
      ActivityOption: [],
      fu_chiefPerson: [], //副负责人
      FriendName: [], //用户绑定人员名称
      FriendRelation: [], //用户绑定关系
      followFormid: "",
      layoutVisible: false, //分配
      auditionGenre: "", //试听类型
      Auditiontime: "", //试听时间
      currentPage: 1,
      // 分页的数据
      dataNumber: 0, //数据总数
      pagenum: "1",
      pagesize: 10,
      basicinformation: [],
      dialogVisible: false,
      //筛选条件
      client_levelvalue: null,
      selectForm: {
        nohavetrack: "",
        client_isnewtip: "", //是否名单更新 1 已读   0未读
        client_level: "",
        client_tracestatus: "",
        chiefPerson: "",
        chiefPerson_fu: "",
        range_time: "", //创建时间
        last_time: "", //最后时间
        keyword: "",
        activity: "",
        ishaveinvite: "",
        ishaveaudition: "",
        channel: "",
        order: "", //排序方式
        client_status: "", //名单状态 0 待分配 1未跟踪 2已邀约 3已试听 4已跟踪 -1 无意向
        client_track_status: "", //跟踪状态 0-待分配 ,1-待跟踪 2-跟踪中,3已转正 -1无意向
        client_answerphone: "", // 是否接通电话 0 未标记 1 已接通 -1 未接通
        channel_id: "",
        frommedia_name: "",
        track_count: "",
        overduetype: 1,
      },
      clientAnswerphoneList: [
        {
          client_answerphone: 0,
          client_answerphone_name: this.$t(
            "views.Customersmanage.custoMersmanage.5zlnqvch6r40"
          ),
        },
        {
          client_answerphone: 1,
          client_answerphone_name: this.$t(
            "views.Customersmanage.custoMersmanage.5zlnqvch6tc0"
          ),
        },
        {
          client_answerphone: 2,
          client_answerphone_name: this.$t(
            "views.Customersmanage.custoMersmanage.5zlnqvch6vo0"
          ),
        },
      ],
      clientLevelNum: "", //存储意向星级数目
      intentionLevelList: [], //意向星级注释列表
      // 客户状态0待跟踪1持续跟踪2已柜询3已试听4已转正-1无意向
      clientOptionList: [
        {
          value: "0",
          label: this.$t("Customersmanage.bs"),
        },
        {
          value: "1",
          label: this.$t("Customersmanage.bt"),
        },
        {
          value: "2",
          label: this.$t("Customersmanage.bu"),
        },
        {
          value: "3",
          label: this.$t("Customersmanage.bv"),
        },
      ],
      clientOption: [
        {
          value: "",
          label: this.$t("Customersmanage.br"),
        },
        {
          value: "0",
          label: this.$t("Customersmanage.bs"),
        },
        {
          value: "1",
          label: this.$t("Customersmanage.bt"),
        },
        {
          value: "2",
          label: this.$t("Customersmanage.bu"),
        },
        {
          value: "3",
          label: this.$t("Customersmanage.bv"),
        },
        // 未柜询
        {
          value: "6",
          label: this.$t("Customersmanage.bvN1"),
        },
        // 未试听
        {
          value: "7",
          label: this.$t("Customersmanage.bvN2"),
        },
        {
          value: "8",
          label: this.$t("Customersmanage.bvN3"),
        },
        {
          value: "9",
          label: this.$t("Customersmanage.bvN4"),
        },
        // {
        //   value: "4",
        //   label: "已转正"
        // },
        // {
        //   value: "-1",
        //   label: "无意向"
        // }
      ],
      // 招生渠道类型
      SchoolsourceOption: [],
      ChannelOption: [],
      OrderFieldOption: [], //获取意向客户排序字段
      chiefPerson: [], //负责人
      SchoolCourseOption: [], //意向课程
      FamilyRelation: [], //获取家庭亲属关系
      repeatList: [], //重复记录列表
      isrepeat: false,
      input: "",
      select: "",
      imageUrl: "",
      levelNum: 5, //侧边栏个数
      sliderWidth: "700px", //侧边栏宽度
      minSliderwidth: "620px",
      activeName: "first",
      buttonHide: false,
      // 侧边栏 资料建档
      form: {
        chinaeseName: "",
        englishName: "",
        sex: "",
        birthday: "",
        memberNum: "",
        familyClassif: "",
        familyName: "",
        familyPhone: "",
        source: "",
        status: "",
        Introducer: "",
        chiefPerson: "",
        deputyPerson: "",
        class: "",
        classInfo: "",
        textarea: "",
      },
      //多条线索信息
      MultipleClues: [],
      Userlistcreate: {
        containClass: "slider-custoMersmanage",
        sliderTitle: this.$t("Customersmanage.ab"),
      },
      Userlistedit: {
        containClass: "slider-custoMersmanage",
        sliderTitle: this.$t("Customersmanage.bw"),
      },
      options: [],
      // 表格数据
      columnWidth: ["200", "200", "150", "150", "250", "250", "250", "250"], //表格宽度
      tableData: [],
      optionscaozuo: {
        mutiSelect: true, // 是否支持列表项选中功能
        loading: true, //数据loading
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        tableHeight: null, //表格高度
        errortip: "",
        mutiSelectTwoDisable: true, //是否disable复选框
        isShowPersonInfo: true, //是否显示个人资料保护法标识
        // specialColumns:true//特殊列
      },
      optionscaozuoTmk: {
        mutiSelect: true, // 是否支持列表项选中功能
        loading: true, //数据loading
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        tableHeight: null, //表格高度
        errortip: "",
        mutiSelectTwoDisable: true, //是否disable复选框
        isShowPersonInfo: true, //是否显示个人资料保护法标识
        // specialColumns:true//特殊列
      },
      columns: [],
      allColumns: [],
      operates: {
        width: 200,
        label: this.$t("Customersmanage.bss"),
        align: "center",
        fixed: "right",
        list: [
          {
            id: "1",
            label: this.$t("Customersmanage.by"),
            type: "text",
            show: true,
            plain: true,
            Customfloow: true,
            disabled: false,
            method: (index, row) => {
              console.warn(row);
              this.rowData = { ...row }
              this.handleClick(row);
            },
          },
          {
            id: "2",
            label: this.$t("Customersmanage.bz"),
            type: "text",
            show: true,
            plain: true,
            turnPositive: true,
            disabled: false,
            method: (index, row) => {
              this.rowData = { ...row }
              this.turnPositive(row);
            },
          },
          {
            id: "3",
            label: this.$t("Customersmanage.cbn"),
            type: "text",
            show: true,
            plain: true,
            delRepeat: true,
            disabled: false,
            isApplayChange: true,
            method: (index, row) => {
              this.rowData = { ...row }
              this.applyChannelRow = row;
              // this.frommediaName = row.channel_medianame
              this.frommediaName = "";
              // this.applyFormData.channel_id = row.channel_id
              this.getSourceApi();
              this.showApplyChange = true;
            },
          },
          // {
          //   id: "4",
          //   showDial: true,
          //   addToDial: true,
          //   method: (index, row) => {
          //     (() => {})(index, row);
          //     this.addClientDialRecordAction([{ client_id: row.client_id }]);
          //   },
          // },
          // {
          //   id: "5",
          //   showDial: true,
          //   dialToPhone: true,
          //   method: (index, row) => {
          //     (() => {})(index, row);
          //   },
          // },
        ],
      }, // 列操作按钮
      tableOperate: {
        label: "",
        operate: true,
        align: "center",
        fixed: "right",
      },
      // 排序方式
      tableSort: {
        label: "",
        operate: true,
        align: "center",
        fixed: "right",
        sortOption: [],
      },
      defaultProps: {
        children: "children",
        label: "label",
      },
      notreadnum: 0, //未读提醒人数
      isShowListTips: true, //是否显示名单更新

      showPhoneDialog: false,

      recommendPopVisable: false, //是否显示推荐人列表
      selecRecomInfo: {}, //选中的推荐人信息
      // 推荐人列表---表格数据
      tableList: {
        // 表格的列
        columns: [],
        // 表格数据
        list: [],
        options: {
          RadioSelect: true,
          errortip: "", //空页面提示内容
          tableHeight: "300px",
        },
      },
      recommendTeacherList: [],
    };
  },
  components: {
    PageNav,
    SliderBox,
    TableList,
    userCreate,
    auditClass,
    userSeeing,
    dialPhone,
    ElImageViewer,
    radioTableCont,
    normalTableCont,
  },
  updated() {
    setTimeout(() => {
      this.fullscreenLoading = false;
    }, 1000);
  },
  created() {
    this.slider = this.$store.state.Slider;
    this.token = this.$Tool.getStorage('token')
    this.marketer_id = this.$Tool.getStorage('marketer_id')
    this.school_id = this.$Tool.getStorage('school_id')
    this.company_id = this.$Tool.getStorage('company_id')
    this.postbe_crmuserlevel = this.$Tool.getStorage("PostbeCrmlevel")
      ? this.$Tool.getStorage("PostbeCrmlevel")
      : "";
    this.re_postbe_id = this.$Tool.getStorage("re_postbe_id")
      ? this.$Tool.getStorage("re_postbe_id")
      : "";
    this.language_type = this.$Tool.getStorage("language")
      ? this.$Tool.getStorage("language")
      : "";
    // 权限判断
    this.postbe_crmlevel = this.$store.state.POSTBE_CRMLEVEL;
    if (this.$route.query.client_tracestatus) {
      this.selectForm.client_tracestatus = this.$route.query.client_tracestatus;
    }
    this.selectForm.nohavetrack = this.$route.query.nohavetrack || "";
    
    this.currentId = this.$route.query.type ? Number(this.$route.query.type) : 4;
    this.selectForm.overduetype = this.currentId;

    this.getgetClientData(this.pagenum);
    this.getSource(); // 获取招生渠道类型
    this.getOrderFieldApi(); //获取意向客户排序字段
    this.getMarketer(); // 获取招生的负责人
    this.getActivityData(); // 获取活动名称

    this.getFamilyRelationData(); // 获取家庭亲属关系
    this.getChannelData();
    this.getIntentionLevelList();
    this.getReMarketerApi();
    this.getIntentionNumFn();
    // if(this.postbe_crmlevel=='1'){
    //   this.optionscaozuo.tableHeight=this.$Common.getTableHeight(375);//设置表格高度
    // }else{
    //   this.optionscaozuo.tableHeight=this.$Common.getTableHeight(360);//设置表格高度
    // }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs["auto_height_table"]) {
        this.optionscaozuo.tableHeight = this.$Common.getTableHeight(
          this.$refs.auto_height_table.getBoundingClientRect().top + 85
        );
      }
      if (this.$refs["auto_height_table_tmk"]) {
        this.optionscaozuoTmk.tableHeight = this.$Common.getTableHeight(
          this.$refs.auto_height_table.getBoundingClientRect().top + 85
        );
      }
    });

    util.$on("test", (v) => {
      console.warn("testtest", v);
      this.handleClick(v);
    });
  },
  watch: {
    callPhoneVisible(n) {
      if (!n) {
        this.errortip = "";
        this.callItem = null;
        this.callPhoneType = "1";
        this.callProcess = "1";
      }
    },
    showApplyChange(n) {
      if (!n) {
        this.applyFormData.frommedia_id = "";
        this.applyFormData.client_teachername = "";
        this.applyFormData.client_teacherid = "";
        this.applyFormData.client_sponsor = "";
        this.applyFormData.recommend_keyword = "";
        this.selecRecomInfo = {};
        this.$refs["applyFormRef"].resetFields();
      }
    },
  },
  methods: {
    getInvalidnoteApi() {
      this.$http.getInvalidnoteApi({}).then((res) => {
        const { code, data: _jb } = res.data;

        const data = _jb;
        if (code === 200) {
          this.followForm.invalidNoteList = data.list;
        } else {
          this.followForm.invalidNoteList = [];
        }
      });
    },
    handleRemoveItem(index) {
      this.MultipleClues.splice(index, 1);
      if (this.MultipleClues.length === 0) {
        this.invalidVisible = false;
        this.$refs["multipleTable"]["$children"][0].clearSelection();
      }
    },
    handleConfimInvalid() {
      this.$refs["followForm"].validate((valid) => {
        if (valid) {
          var arrMultiple = [];
          this.MultipleClues.forEach((item) => {
            arrMultiple.push(item.client_id);
          });
          storeCustoMersmanage
            .changeIntentionClientApi({
              type: -2,
              client_id: arrMultiple,
              invalidnote_code: this.followForm.invalidnote_code,
              invalidnote_reason: this.followForm.invalidNoteList.find(
                (item) =>
                  item.invalidnote_code == this.followForm.invalidnote_code
              )["invalidnote_reason"],
            })
            .then((res) => {
              const { code, msg } = res.data;
              this.$message({
                type: code === 200 ? "success" : "error",
                message: msg,
              });
              if (code === 200) {
                this.getgetClientData();
                this.getIntentionNumFn()
                this.invalidVisible = false;
              }
            });
        }
      });
    },
    handClose(done) {
      done();
    },

    getIntentionNumFn() {
      storeCustoMersmanage.getIntentionNum({}).then((res) => {
        const { code, data: _jb } = res.data;

        const data = _jb;
        if (code === 200) {
          this.filtersOption[0].value = data.list.SouCiWeiGenJin;
          // this.filtersOption[1].value = data.list.WeiJieTong;
          this.filtersOption[2].value = data.list.yuqi;
          this.filtersOption[3].value = data.list.yujing;
        } else {
          this.filtersOption[0].value = 0;
          // this.filtersOption[1].value = 0;
          this.filtersOption[2].value = 0;
          this.filtersOption[3].value = 0;
        }
      });
    },
    changeFilter(item) {
      this.currentId = item.id;
      this.selectForm.overduetype = item.id;
      this.currentPage = 1;
      this.pageSize = 10;
      this.getIntentionNumFn();
      this.getgetClientData();
    },
    callClientMobileAction() {
      storeCustoMersmanage
        .callClientMobileAction({
          client_id: this.callItem.client_id,
          numbertype: this.callPhoneType,
        })
        .then((res) => {
          const { code, msg } = res.data;
          this.errortip = msg;
          if (code === 200) {
            this.callProcess = 2;
          } else {
            this.callProcess = 3;
          }
        });
    },

    filterClientTeacher() {
      let list = this.recommendTeacherList.filter(
        (v) => this.applyFormData.client_teacherid == v.staffer_id
      );
      if (list.length > 0) {
        this.applyFormData.client_teachername = list[0]["staffer_cnname"];
      } else {
        this.applyFormData.client_teachername = "";
      }
    },
    getReMarketerApi() {
      storeCustoMersmanage.getReMarketerApi({}).then((res) => {
        if (res.data.code === 200) {
          this.recommendTeacherList = res.data.data.list;
        } else {
          this.recommendTeacherList = [];
        }
      });
    },
    updateList() {
      this.getgetClientData(this.pagenum);
    },
    // handConfirm(val) {
    //
    //   // this.getgetClientData();

    // },
    // handleSelectChange(val) {
    //   this.updateClientAnswerPhoneAction(val);
    // },
    // 跟新电话接通状态
    updateClientAnswerPhoneAction(val) {
      storeCustoMersmanage
        .updateClientAnswerPhoneAction({
          client_id: this.customerId, // 客户id
          client_answerphone: val, // 接通状态
        })
        .then((res) => {
          (() => {})(res);
          const { code, msg } = res.data;
          if (code === 200) {
            this.$message({
              type: "success",
              message: msg,
            });
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
        });
    },
    // 关闭查看器
    closeViewer() {
      this.showViewer = false;
    },

    handleRemove(file, fileList) {
      (() => {})(file, fileList);
    },
    handlePictureCardPreview(file) {
      (() => {})(file);
      // this.dialogImageUrl = file.url;
      this.applyFormData.channellog_img2 = file.response.data.picture_imgurl;
      this.dialogVisibles = true;
    },

    // 新增拨打电话需求
    batchAddPhone() {
      let arr = [];
      this.MultipleClues.map((v) => {
        arr.push({ client_id: v.client_id });
      });
      this.addClientDialRecordAction(arr);
    },
    addClientDialRecordAction(v) {
      storeCustoMersmanage
        .addClientDialRecordAction({
          client_list: JSON.stringify(v),
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getgetClientData();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    // 公共->意向星级注释列表->zjc
    getIntentionLevelList() {
      this.$http.getIntentionLevelList({}).then((res) => {
        let list = res.data.data.list;
        let arr = [];
        list.forEach((e) => {
          arr.push(e.intentlevel_remark);
        });
        this.intentionLevelList = arr;
      });
    },
    handDialPhone() {
      this.showPhoneDialog = true;
      (() => {})(234);
    },
    hidePhoneDialog(data) {
      this.showPhoneDialog = data;
    },

    emitShowImg(v) {
      console.warn(v.split(","));
      this.showImgUrl = v.split(",");
      this.showImgMask = true;
      this.showViewer = true;
    },
    applyChannelChange() {
      this.applyFormData.sourceList.forEach((e) => {
        if (e.frommedia_id == this.applyFormData.frommedia_id) {
          this.frommediaName = e.frommedia_name;
        }
      });
      this.applyFormData.channel_id = "";
      this.getChannel();
    },
    handleApply() {
      this.$refs.uploadRef.clearFiles();
      this.$refs["applyFormRef"].validate((v) => {
        if (v) {
          this.applyChannelAction();
        } else {
          return false;
        }
      });
    },

    remotePromotion(query) {
      if (query) {
        this.loading = true;
        this.$http
          .getGroundPromotionApi({
            promotion_jobnumber: query,
          })
          .then((res) => {
            const { code, data: _jb } = res.data;

            const data = _jb;
            if (code === 200) {
              this.groundPromotionList = data.list;
            } else {
              this.groundPromotionList = [];
            }
            this.loading = false;
          });
      } else {
        this.groundPromotionList = [];
      }
    },
    // 申请变更
    applyChannelAction() {
      storeCustoMersmanage
        .applyChannelAction({
          client_id: this.applyChannelRow.client_id,
          from_channel_id: this.applyChannelRow.channel_id,
          to_channel_id: this.applyFormData.channel_id,
          channellog_changetime: this.applyFormData.channellog_changetime,
          client_teacherid: this.applyFormData.client_teacherid,
          client_teachername: this.applyFormData.client_teachername,
          client_sponsor: this.applyFormData.client_sponsor,
          recommend_keyword: this.applyFormData.recommend_keyword,
          // channellog_img: this.applyFormData.channellog_img,
          channellog_img: JSON.stringify(this.applyFormData.channellog_img),
          channellog_note: this.applyFormData.reason,
          channellog_level: this.applyFormData.degree,
          promotion_id: this.applyFormData.promotion_id,
          student_branch: this.selecRecomInfo.student_branch || "",
        })
        .then((res) => {
          const { code, msg } = res.data;
          if (code === 200) {
            this.getgetClientData();
            this.showApplyChange = false;
            this.$message.success(msg);
          } else {
            this.$message.error(msg);
          }
        });
    },

    getSourceApi() {
      this.$http.getSource({}).then((res) => {
        (() => {})(res);
        const { data } = res.data;
        data.list.forEach((e) => {
          if (e.frommedia_name == this.frommediaName) {
            this.applyFormData.frommedia_id = e.frommedia_id;
          }
        });
        this.applyFormData.sourceList = data.list;
        this.getChannel();
      });
    },
    getChannel() {
      this.$http
        .getChannel({
          channel_medianame: this.frommediaName,
        })
        .then((res) => {
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.applyFormData.channelList = data.list;
          } else {
            this.applyFormData.channelList = [];
          }
        });
    },
    removeUser(i) {
      this.chooseUserList.splice(i, 1);
    },
    // 招生有效名单表格数据
    getgetClientData() {
      storeCustoMersmanage
        .getHome({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id,
          is_count: "1", //是否需要总数，可以不传
          p: this.currentPage,
          num: this.pagesize,
          overduetype: this.selectForm.overduetype,
          postbe_crmuserlevel: this.postbe_crmlevel,
          // 非必须传
          frommedia_name: this.selectForm.frommedia_name,
          channel_id: this.selectForm.channel_id,
          main_marketer_id: this.selectForm.chiefPerson,
          fu_marketer_id: this.selectForm.chiefPerson_fu,
          track_intention_level: this.clientLevelNum,
          client_tracestatus: this.selectForm.client_tracestatus,
          keyword: this.selectForm.keyword,
          activity_id: this.selectForm.activity,
          ishaveinvite: this.selectForm.ishaveinvite,
          ishaveaudition: this.selectForm.ishaveaudition,
          order: this.selectForm.order,
          client_isnewtip: this.selectForm.client_isnewtip, //是否名单更新
          nohavetrack: this.selectForm.nohavetrack, //是否名单更新
          create_starttime: this.selectForm.range_time
            ? this.selectForm.range_time[0]
            : "",
          create_endtime: this.selectForm.range_time
            ? this.selectForm.range_time[1]
            : "",
          track_createtime: this.selectForm.last_time
            ? this.selectForm.last_time[0]
            : "",
          track_endtime: this.selectForm.last_time
            ? this.selectForm.last_time[1]
            : "",
          client_answerphone: this.selectForm.client_answerphone,
          track_count: this.selectForm.track_count,
          // client_status: this.selectForm.client_status,
          // client_track_status: this.selectForm.client_track_status
        })
        .then((res) => {
          const { code, msg, data: body } = res.data;
          const allnum = body.allnum;
          const data = body;

          let list = data.list;
          list.forEach((item) => {
            item.overduetype = this.selectForm.overduetype;
          });
          this.tableData = list;
          this.dataNumber = parseInt(allnum);
          // this.data=data.field;
          var Columns = data.field;
          this.allColumns = data.field;
          this.$Tool.setStorage("allColumns", this.allColumns);
          this.showColumn = JSON.parse(localStorage.getItem("showColumns"));
          var fieldColumns = data.field;
          if (JSON.parse(localStorage.getItem("showColumns"))) {
            Columns = this.showColumn;
            fieldColumns = this.showColumn;
          }
          this.columns = this.$Common.handleTable(
            Columns,
            this.columnWidth,
            true,
            0
          );
          this.optionscaozuo.loading = false;
          this.optionscaozuoTmk.loading = false;
          var arr = [];
          var arr2 = [];
          fieldColumns.forEach((item, index) => {
            arr.push({
              key: index,
              label: item.fieldstring,
              disabled: item.custom === "0",
            });
            if (item.show == "0") {
              arr2.push(index);
            }
          });
          this.data = arr;
          this.oprateColumn = arr2;
          if (code !== 200) {
            this.optionscaozuo.errortip = msg;
            this.optionscaozuoTmk.errortip = msg;
          }
          this.notreadnum = data.notreadnum;
        });
    },
    // 编辑列
    Changeoprate() {
      (() => {})(
        this.$t("views.Customersmanage.custoMersmanage.5zlnqvch6y40")
      );
    },
    //获取意向客户排序字段
    getOrderFieldApi() {
      storeCustoMersmanage
        .getOrderFieldApi({
          company_id: this.company_id,
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
        })
        .then((res) => {
          var d = res.data.data || res.data;
          var raw =
            res.data.list ||
            (res.data.result && res.data.result.list) ||
            (d && d.list) ||
            (d && d.result && d.result.list) ||
            (Array.isArray(d) ? d : []);
          this.OrderFieldOption = Array.isArray(raw) ? raw.slice() : [];
          this.OrderFieldOption.unshift({
            field: "",
            name: this.$t("Customersmanage.br"),
          });
          this.tableSort.sortOption = this.OrderFieldOption;
        });
    },
    //获取活动名称
    getActivityData() {
      storeCustoMersmanage
        .getActivity({
          company_id: this.company_id,
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
        })
        .then((res) => {
          this.ActivityOption = res.data.data.list;
        });
    },
    //获取招生渠道类型
    getSource() {
      this.$http
        .getSource({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          this.SchoolsourceOption = res.data.data.list;
        });
    },
    //获取招生渠道明细
    getChannelData() {
      this.$http
        .getChannel({
          company_id: this.company_id,
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          channel_medianame: this.selectForm.frommedia_name,
        })
        .then((res) => {
          this.ChannelOption = res.data.data.list;
        });
    },
    // 招生渠道类型筛选
    frommediaSearch() {
      this.selectForm.channel_id = "";
      this.getChannelData(); // 获取渠道明细
      this.handleSelect();
    },
    // 获取招生的负责人
    getMarketer() {
      storeCustoMersmanage
        .getMarketer({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.chiefPerson = res.data.data.list;
          // this.chiefPerson.unshift(
          //   {
          //     marketer_id: "", marketer_name: "不限"
          //   })
        });
    },
    //获取意向课程
    getTypeCourseCatApi() {
      // SchoolClassOption
      this.$http
        .getTypeCourseCatApi({
          coursetype_id: "",
        })
        .then((res) => {
          this.SchoolCourseOption = res.data.data.list;
        });
    },
    // 获取家庭亲属关系
    getFamilyRelationData() {
      storeCustoMersmanage
        .getFamilyRelation({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          (() => {})(res.data);
          this.FamilyRelation = res.data.data.list;
        });
    },
    // 意向客户->CRM获取转正课程
    conversionCourseApi() {
      storeCustoMersmanage
        .conversionCourseApi({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          console.log('res111',res)
          this.courseBranchList = res.data.data.value;
        });
    },
    // 选择意向星级查询
    handleSelectLevel() {
      if (this.clientLevelNum == this.client_levelvalue) {
        this.client_levelvalue = null;
        this.clientLevelNum = "";
      } else {
        this.clientLevelNum = this.client_levelvalue;
      }
      this.currentPage = 1;
      this.getgetClientData(this.pagenum);
    },
    // 选择查询
    handleSelect() {
      this.currentPage = 1;
      this.getgetClientData(this.pagenum);
    },
    // 输入关键词查询
    handleSelectKeyword() {
      this.currentPage = 1;
      this.getgetClientData(this.pagenum);
    },

    cancelChangePhone() {
      this.repeatVisible = false;
      this.showSliderBox = false;
      this.$message.error(
        this.$t("views.Customersmanage.custoMersmanage.5zlnqvch7180")
      );
    },
    submitChangePhone() {
      let data = JSON.parse(this.jsonData);
      data.client_source = this.$t(
        "views.Customersmanage.custoMersmanage.5zlnqvch7400"
      );
      data.channel_id = "577";
      this.addIntentionclientData(data);
    },
    // 新增意向客户
    addIntentionclientData(data) {
      storeCustoMersmanage.addIntentionclient(data).then((res) => {
        (() => {})(res.data);
        if (res.data.code === 200) {
          // this.$Tool.successTip(res.data.msg);
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          // this.current=0;
          this.repeatVisible = false;
          this.getgetClientData(this.pagenum);
          this.showSliderBox = false;
        } else {
          const { isTipsPhoneChannel } = res.data.data;
          if (isTipsPhoneChannel == 1) {
            this.repeatVisible = true;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        }
      });
    },
    // 编辑意向客户
    editClientData(data) {
      storeCustoMersmanage.editClient(data).then((res) => {
        (() => {})(res.data);
        if (res.data.code === 200) {
          // this.$Tool.successTip(res.data.msg);
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.getgetClientData(this.pagenum, "");
          this.showSliderBoxEdit = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //编辑时删除家庭信息
    deleteFamily(v) {
      if (v.family_id) {
        storeCustoMersmanage
          .delFamilyRelation({
            marketer_id: this.marketer_id,
            token: this.token,
            company_id: this.company_id,
            school_id: this.school_id,
            family_id: v.family_id,
          })
          .then((res) => {
            if (res.data.code === 200) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.getgetClientData(this.pagenum, "");
              // this.showSliderBox=false;
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
      }
    },
    //编辑时删除课程信息
    deleteCourse(v) {
      if (v.intention_id) {
        storeCustoMersmanage
          .delIntentionSource({
            marketer_id: this.marketer_id,
            token: this.token,
            company_id: this.company_id,
            school_id: this.school_id,
            intention_id: v.intention_id,
          })
          .then((res) => {
            if (res.data.code === 200) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.getgetClientData(this.pagenum, "");
              // this.showSliderBox=false;
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
      }
    },
    // 获取单个客户的基本信息
    getclientOneData(id) {
      storeCustoMersmanage
        .getclientOne({
          marketer_id: this.marketer_id,
          token: this.token,
          client_id: id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.UserInformation = res.data.data.list;
        });
    },
    // 新增时-检测重名
    checkIntentionClientData(val) {
      var id;
      if (this.isEdit) {
        id = this.customerId;
      } else {
        id = "";
      }
      storeCustoMersmanage
        .checkIntentionClient({
          token: this.token,
          marketer_id: this.marketer_id,
          client_cnname: val.client_cnname,
          client_mobile: val.client_mobile,
          company_id: this.company_id,
          school_id: this.school_id,
          client_id: id,
        })
        .then((res) => {
          (() => {})(res.data);
          if (res.data.code === 200) {
            this.isrepeat = false;
          } else {
            if (res.data.data.list != undefined) {
              const { list, field } = res.data.data;
              this.isrepeat = true;
              this.repeatList = list;
              this.repeatData.list = list;
              this.repeatData.columns = field;
            }
          }
        });
    },
    // 转为招生有效名单/无意向
    handleClickclueloss(type) {
      // 流转类型 1-转为线索 - 1 转为无意向客户
      (() => {})(this.MultipleClues);
      var arrMultiple = [];
      this.MultipleClues.forEach((item) => {
        arrMultiple.push(item.client_id);
      });
      storeCustoMersmanage
        .changeIntentionClient({
          marketer_id: this.marketer_id,
          token: this.token,
          client_id: arrMultiple,
          type: type,
        })
        .then((res) => {
          (() => {})(res.data);
          if (res.data.code === 200) {
            // this.$Tool.successTip(res.data.msg);
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getgetClientData(this.pagenum);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    // 获取单个客户的绑定关系
    getFriendRelationData(id) {
      storeCustoMersmanage
        .getFriendRelation({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_id: id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.FriendRelation = res.data.data.list;
        });
    },
    // 绑定学员->获取人员名称
    getClientNameData(keyword) {
      storeCustoMersmanage
        .getClientName({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_cnname: keyword,
        })
        .then((res) => {
          // (() => {})(res.data.data.list);
          this.FriendName = res.data.data.list;
          this.loading = false;
        });
    },
    // 远程搜索绑定学员的名称
    remoteMethod(query) {
      (() => {})(query);
      if (query !== "") {
        this.loading = true;
        this.getClientNameData(query);
      } else {
        this.FriendName = [];
      }
    },
    //绑定学员提交
    onBindSubmit() {
      // (() => {})(this.BindstudentFrom);
      storeCustoMersmanage
        .bindingClient({
          token: this.token,
          marketer_id: this.marketer_id,
          from_client_id: this.from_client_id,
          to_client_id: this.BindstudentFrom.name,
          binding_friend_relation: this.BindstudentFrom.relation,
        })
        .then((res) => {
          // (() => {})(res.data);
          if (res.data.code === 200) {
            // this.$Tool.successTip(res.data.msg);
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getgetClientData(this.pagenum, "");
            this.createJG = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    // 绑定学员显示
    studentBinding() {
      this.BindstudentFrom = {
        name: "",
        relation: "",
      }; //数据初始化
      this.getFriendRelationData();
      this.createJG = true;
    },
    //查看点击编辑
    Clickedit() {
      this.getTypeCourseCatApi();
      this.showSliderBoxSee = false;
      this.showSliderBoxEdit = true;
      this.isEdit = true;
      // this.getclientOneData(this.customerId);
    },
    //点击查看
    handleColumnChange(k, v) {
      this.isRoot = false;
      this.activeName = "first";
      this.isTrack = false;
      this.iscanEdit = true;
      this.from_client_id = v.client_id;
      this.customerId = v.client_id; //存储客户ID
      this.getclientOneData(v.client_id);
      // this.getclientOneData(v.client_id);
      // this.getclientOneTrackData(v.client_id);
      // this.getFriendRelationData(v.client_id);
      // this.getclientOneInviteData(v.client_id); //柜询记录
      // this.getclientOneAuditionData(v.client_id); //试听记录
      // this.getBindingClientData(v.client_id);//绑定学员信息
      this.showSliderBoxSee = true;
    },
    emitCallPhone(val) {
      this.rowData = { ...val }
      this.callItem = val;
      this.callPhoneVisible = true;
    },

    //跟班试听
    leaning() {
      this.leaningVisible = true;
    },
    // 试听类型
    ClickAudition(v) {
      this.auditionGenre = v;
    },
    // 试听时间
    ClickAuditiontime(v) {
      (() => {})(v, 121213);
      this.Auditiontime = v;
    },
    handClickcompare(v) {
      (() => {})(v);
      this.ClassMessage = v;
      this.leaningVisible = false;
    },
    handClickcancel() {
      this.leaningVisible = false;
    },
    handleCloseLean() {
      this.$confirm(this.$t("Customersmanage.cb"))
        .then(() => {
          this.leaningVisible = false;
        })
        .catch((_) => {
          (() => {})(_);
        });
    },
    // 转正
    turnPositive(v) {
      (() => {})(v);
      // this.PositiveFrom={
      //   student_branch: "",//学生编号
      //   course_branch: "",//课程编号
      //   positivelog_time: "",//转正日期
      //   positvelog_note: "",//转正备注
      // };//数据清空
      this.conversionCourseApi(); // 意向客户->CRM获取转正课程
      this.positiveVisable = !this.positiveVisable;
      this.PositiveFrom.positvelog_note = "";
      this.clientId = v.client_id;
      if (this.$refs["PositiveFrom"]) {
        this.$refs["PositiveFrom"].resetFields();
      }
    },
    // Crm->删除重复名单
    delRepeatAction() {
      this.$http
        .delRepeatAction({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id,
          client_id: this.clientId,
          postbe_crmlevel: this.postbe_crmlevel,
        })
        .then((res) => {
          // (() => {})(res.data);
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getgetClientData(this.pagenum);
            this.delRepeat = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    //转正学员提交
    onTurnSubmit() {
      this.$refs["PositiveFrom"].validate((valid) => {
        if (valid) {
          storeCustoMersmanage
            .conversionAction({
              token: this.token,
              marketer_id: this.marketer_id,
              client_id: this.clientId,
              student_branch: this.PositiveFrom.student_branch,
              course_branch: this.PositiveFrom.course_branch,
              positivelog_time: this.PositiveFrom.positivelog_time,
              positvelog_note: this.PositiveFrom.positvelog_note,
            })
            .then((res) => {
              // (() => {})(res.data);
              if (res.data.code === 200) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.getgetClientData(this.pagenum, "");
                this.positiveVisable = false;
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
        } else {
          (() => {})("error submit!!");
          return false;
        }
      });
    },
    // 我要跟进
    handleClick(v) {
      // 判断是否为我的意向客户*** 0 时跟进显示灰色
      if (v.client_forbid == "0") {
        this.TipsVisible = true;
        (() => {})(v);
        if (v.client_tracestatus == "4") {
          this.TipsText = this.$t("Customersmanage.cc");
        } else {
          this.TipsText = this.$t("Customersmanage.cd");
        }
      } else {
        this.isRoot = true;
        this.iscanEdit = false;
        this.isTrack = true; //是否点击我要跟进
        this.from_client_id = v.client_id;
        this.followFormid = v.client_id; //跟进
        this.customerId = v.client_id; //存储客户ID
        this.getclientOneData(v.client_id);
        this.showSliderBoxSee = true;
      }
    },
    //跟进提交
    onFllowSubmit(v) {
      // v.track_intention_level = this.clientLevelNum.length;
      v.token = this.token;
      v.marketer_id = this.marketer_id;
      v.school_id = this.school_id;
      v.company_id = this.company_id;
      if (this.followFormid != "") {
        v.client_id = this.followFormid;
      }
      storeCustoMersmanage.settingtrackClient(v).then((res) => {
        (() => {})(res.data);
        if (res.data.code === 200) {
          // this.$Tool.successTip(res.data.msg);
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.getgetClientData(this.pagenum, "");
          this.getIntentionNumFn();
          this.showSliderBoxSee = false;
          this.showSliderBox = false;
          // 数据清空
          // this.ClassMessage={};
        } else {
          // this.isFllowError=true;
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    // 绑定学员点击跟进
    ClickFloow(v) {
      this.customerId = v.client_id;
    },
    // 显示 列切换
    toggleEditableColumn() {
      (() => {})("显示 列切换");
      this.settingVisible = !this.settingVisible;
    },
    // 点击排序方式***功能菜单
    handleCommandSort(command) {
      (() => {})(command);
      this.selectForm.order = command;
      this.currentPage = 1;
      this.getgetClientData(this.pagenum);
    },
    // 自定义编辑列
    handClickOprate() {
      let allnum = JSON.parse(localStorage.getItem("allColumns"));
      allnum.forEach((item, index) => {
        allnum[parseInt(index)].show = "1";
      });
      this.oprateColumn.forEach((item) => {
        allnum[parseInt(item)].show = "0";
      });
      this.showColumns = allnum;
      this.$Tool.setStorage("showColumns", this.showColumns);
      this.settingVisible = false;
      this.getgetClientData(this.pagenum);
      (() => {})(allnum);
    },
    hideSliderBox() {
      this.showSliderBox = false;
    },
    hideSliderBoxEdit() {
      this.showSliderBoxEdit = false;
    },
    hideSliderSeeBox() {
      this.showSliderBoxSee = false;
    },
    handleDel() {
      this.dialogVisible = true;
    },
    // 新增意向客户
    onSubmit(value) {
      (() => {})(value);
      value["marketer_id"] = this.marketer_id;
      value["token"] = this.token;
      value["school_id"] = this.school_id;
      value["company_id"] = this.company_id;
      var isnull =
        value.client_cnname != "" &&
        value.client_sex != "" &&
        value.client_mobile != "" &&
        value.main_marketer_id != "";
      if (isnull) {
        this.jsonData = JSON.stringify(value);
        this.addIntentionclientData(value);
      } else {
        this.$message({
          message: this.$t("Customersmanage.cg"),
          type: "error",
        });
      }
    },
    //编辑招生意向客户
    oneditSubmit(value) {
      // value["marketer_id"] = this.marketer_id;
      // value["token"] = this.token;
      // value["school_id"] = this.school_id;
      // value["company_id"] = this.company_id;
      let newVal = value;
      newVal["marketer_id"] = this.marketer_id;
      newVal["token"] = this.token;
      newVal["school_id"] = this.school_id;
      newVal["company_id"] = this.company_id;
      this.$delete(newVal, "client_tag");
      this.$delete(newVal, "client_tags");
      var isnull =
        value.client_cnname != "" &&
        value.client_sex != "" &&
        value.client_mobile != "";
      if (isnull) {
        // this.editClientData(value);
        this.editClientData(newVal);
      } else {
        this.$message({
          message: this.$t("Customersmanage.cg"),
          type: "error",
        });
      }
    },
    // 我要跟踪
    wantToTrack(v) {
      this.getclientOneData(v.client_id);
      this.isRoot = true;
      this.iscanEdit = false;
      //  this.showSliderCreateBox=false;
      this.isTrack = true; //是否点击我要跟进
      this.from_client_id = v.client_id;
      this.followFormid = v.client_id; //跟进
      this.customerId = v.client_id; //存储客户ID
      this.getclientOneData(v.client_id);
      this.showSliderBoxSee = true;
    },
    handleSliderClick(v) {
      (() => {})(v), 11111111;
      if (v == "first") {
        this.iscanEdit = true;
        this.getclientOneData(this.customerId);
      } else {
        if (v == "fourth") {
          this.isRoot = true;
          this.iscanEdit = false;
        } else {
          this.iscanEdit = false;
        }
      }
    },
    changeSize() {
      (() => {})("change");
    },
    handleClose(done) {
      // this.$refs.uploadRef.clearFiles();
      this.$confirm(this.$t("Customersmanage.cb"))
        .then((_) => {
          (() => {})(_);
          done();
        })
        .catch((_) => {
          (() => {})(_);
        });
    },
    handleSizeChange(val) {
      (() => {})(`每页 ${val} 条`);
      this.pagesize = val;
      this.getgetClientData(this.pagenum);
    },
    handleCurrentChange(val) {
      (() => {})(`当前页: ${val}`);
      this.currentPage = val;
      this.getgetClientData(val);
    },

    // handleAvatarSuccess(res) {
    //   if (res.code === 200) {
    //     this.applyFormData.channellog_img = res.data.picture_imgurl;
    //   }
    // },
    handleAvatarSuccess(response, file, fileList) {
      console.warn(response);
      // console.warn(file)
      // console.warn(fileList)
      // if (res.code === 200) {
      //   this.applyFormData.channellog_img = res.data.picture_imgurl;
      // }
      this.applyFormData.channellog_img = fileList.map((item) => {
        return item.response.data.picture_imgurl;
      });
      (() => {})(this.applyFormData.channellog_img);
    },
    beforeAvatarUpload(file) {
      (() => {})(file);
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isGIF = file.type === "image/gif";
      const isImg = isJPG || isPNG || isGIF;
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG && !isGIF) {
        this.$message.error(" 上传图片只能是 JPG/PNG/GIF 格式 !");
      }
      if (!isLt2M) {
        this.$message.error(" 上传图片大小不能超过 2MB!");
      }

      return isImg && isLt2M;
    },
    handleSelectionChange(val) {
      this.MultipleClues = val;
      this.isFromGmc = val.some(
        (v) => v.isgmcIndschoolenter == 1 && v.isgmcschoolenter != 1
      );
      this.buttonHide = val.length > 0;

      this.$nextTick(() => {
        if (this.$refs["auto_height_table"]) {
          this.optionscaozuo.tableHeight = this.$Common.getTableHeight(
            this.$refs.auto_height_table.getBoundingClientRect().top + 85
          );
        }
        if (this.$refs["auto_height_table_tmk"]) {
          this.optionscaozuoTmk.tableHeight = this.$Common.getTableHeight(
            this.$refs.auto_height_table.getBoundingClientRect().top + 85
          );
        }
      });
    },
    // 导出操作
    daochu() {
      let params_str = "",
        is_export = 1;
      let url = storeCustoMersmanage.getHome1();
      let create_starttime = this.selectForm.range_time
        ? this.selectForm.range_time[0]
        : "";
      let create_endtime = this.selectForm.range_time
        ? this.selectForm.range_time[1]
        : "";
      let track_createtime = this.selectForm.last_time
        ? this.selectForm.last_time[0]
        : "";
      let track_endtime = this.selectForm.last_time
        ? this.selectForm.last_time[1]
        : "";
      params_str = `&main_marketer_id=${this.selectForm.chiefPerson}&fu_marketer_id=${this.selectForm.chiefPerson_fu}&track_intention_level=${this.clientLevelNum}&keyword=${this.selectForm.keyword}&client_tracestatus=${this.selectForm.client_tracestatus}&activity_id=${this.selectForm.activity}&order=${this.selectForm.order}&create_starttime=${create_starttime}&create_endtime=${create_endtime}&track_createtime=${track_createtime}&track_endtime=${track_endtime}`;
      params_str = `${url}?marketer_id=${this.marketer_id}&token=${this.token}&school_id=${this.school_id}&company_id=${this.company_id}&re_postbe_id=${this.re_postbe_id}&postbe_crmuserlevel=${this.postbe_crmuserlevel}&language_type=${this.language_type}&is_export=${is_export}${params_str}`;
      if (this.tableData.length > 0) {
        window.open(this.$buildExportUrl(params_str), "_blank");
      } else {
        this.$message.error(this.$t("Common.exportTips"));
      }
    },
    // 检索推荐人
    searchRecomend() {
      if (this.applyFormData.recommend_keyword == "") {
        this.$message({
          message: this.$t("User.errorMessage1"),
          type: "error",
        });
      } else {
        this.getClientStudentApi(); //招生有效名单->获取可选推荐人-lujing
      }
    },
    getClientStudentApi() {
      storeCustoMersmanage
        .getClientStudentApi({
          keyword: this.applyFormData.recommend_keyword, //渠道类型名称
        })
        .then((res) => {
          const { code, msg, data: body } = res.data;
          const data = body;
          this.tableList.columns = data.field;
          if (code === 200) {
            this.tableList.list = data.list;
          } else {
            this.tableList.list = [];
          }
          this.tableList.options.errortip = msg;
          this.recommendPopVisable = true;
        });
    },
    singleBox(val) {
      this.selecRecomInfo = val;
      this.recommendPopVisable = false;
      this.applyFormData.client_sponsor = val.student_cnname;
    },
  },
  computed: {
    company_isassist() {
      return this.$store.state.companyIsassist;
    },
    companyIsNoIntention() {
      return this.$store.state.companyIsNoIntention;
    },
    seatsIntentionLevel() {
      return this.$store.state.seatsIntentionLevel
    }
  },
};
</script>
<style lang="less">
@import url("../../assets/less/manage.less");
@import url("channelRecord.less");
.show-img__mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000000;
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
.channelRecord {
  height: 100vh;
  font-size: 20px;
  .apply-channel__desc {
    display: flex;
    margin: 0 -20px;
    line-height: 35px;
    align-items: center;
    justify-content: center;
    color: rgba(32, 168, 216, 1);
    background-color: rgba(32, 168, 216, 0.14);
  }
  .apply-channel__notice {
    color: red;
  }
  .apply-user-pop {
    display: flex;
    padding: 20px;
    align-items: center;
    .user-info__img {
      width: 120px;
      padding-right: 13px;
      display: flex;
      justify-content: flex-end;
      img {
        display: block;
        width: 53px;
        height: 53px;
        border-radius: 50%;
      }
    }
    .user-info__name {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
      display: flex;
      align-items: center;
      .user-tips {
        margin-left: 20px;
        padding: 0 8px;
        font-size: 14px;
        line-height: 30px;
        font-style: normal;
        color: rgba(32, 168, 216, 1);
        border-radius: 5px;
        background-color: rgba(32, 168, 216, 0.05);
      }
    }
  }
  .choose-user-row {
    display: flex;
    padding: 0 20px;
    .tit {
      width: 100px;
    }

    .user-content {
      flex: 1;
      padding-top: 2px;
      margin-bottom: 0px;
      display: flex;
      flex-wrap: wrap;
    }

    .user-content-item {
      margin: 0 30px 15px 0;
      position: relative;
      .el-icon-circle-close {
        top: -5px;
        right: -15px;
        position: absolute;
        color: red;
        cursor: pointer;
        &:hover {
          color: #20a8d8;
        }
      }
    }
  }

  .selected-people-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .selected-people-item {
      padding: 4px 8px;
      margin-right: 10px;
      border-radius: 4px;
      background: #ffffff;
      border: 1px solid #dedede;
    }
  }
}

#uploadSty {
  .el-dialog__wrapper {
    overflow: hidden !important;
  }
  .el-dialog {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100% !important;
    height: 100% !important;
    margin: 0 !important;
  }
  .el-dialog__header {
    padding: 0 !important;
    height: 50px;
  }
  .el-dialog__body {
    border: none !important;
  }
}
// .v-modal {
//   z-index: -99 !important;
// }

#dialogSty {
  .el-dialog__header {
    padding: 0 !important;
    height: 50px;
  }
  .el-dialog__body {
    border: none !important;
  }
}

#viewerStyle {
  .el-image-viewer__wrapper {
    position: fixed;
    background: rgba(0, 0, 0, 0.3);
    top: 0px;
    left: 0px;
    max-height: 100%;
    max-width: 100%;
    width: 100%;
    height: 100%;
  }
  .el-image-viewer__btn {
    color: #777;
  }
  .el-image-viewer__close {
    position: absolute;
    right: 0;
    z-index: 20000000;
  }
  .el-image-viewer__prev {
    position: absolute;
    top: 50%;
    left: 5%;
    z-index: 20000000;
  }
  .el-image-viewer__next {
    position: absolute;
    top: 50%;
    right: 5%;
    z-index: 20000000;
  }
  .el-icon-arrow-left {
    font-size: 80px;
  }
  .el-icon-arrow-right {
    font-size: 80px;
  }
  .el-icon-circle-close {
    font-size: 40px;
  }
  .el-icon-zoom-out {
    font-size: 40px;
  }
  .el-icon-zoom-in {
    font-size: 40px;
  }
  .el-icon-full-screen {
    font-size: 40px;
  }
  .el-icon-refresh-left {
    font-size: 40px;
  }
  .el-icon-refresh-right {
    font-size: 40px;
  }
  .el-icon-arrow-left:hover,
  .el-icon-arrow-right:hover,
  .el-icon-circle-close:hover,
  .el-icon-zoom-out:hover,
  .el-icon-zoom-in:hover,
  .el-icon-full-screen:hover,
  .el-icon-refresh-left:hover,
  .el-icon-refresh-right:hover {
    cursor: pointer;
  }
  .el-image-viewer__actions__inner {
    position: absolute;
    left: 50%;
    bottom: 5%;
    z-index: 20000000;
    background-color: #888;
  }
  .el-image-viewer__canvas img {
    margin: auto !important;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
}
</style>
<style lang="less" scoped>
.content-nav--head {
  padding: 0px 20px 0px 0px;
  .filter-condition li {
    padding: 0px 20px;
    position: relative;
    .tag-label {
      position: relative;
    }
    .tag-num {
      position: absolute;
      top: -10px;
      left: 100%;
      background-color: red;
      color: #fff;
      height: 20px;
      padding: 0 8px;
      border-radius: 20px;
      font-size: 12px;
      text-align: center;
      line-height: 20px;
      white-space: nowrap;
    }
  }
}
</style>
